function timer() {

  if ($('.promotion__timer').length > 0) {

    function parseDate(dateStr) {
      // Разделяем строку по пробелам, чтобы получить дату и время
      const [datePart, timePart] = dateStr.split(' ');
      // Разделяем по точкам и преобразуем в формат mm/dd/yyyy
      const [day, month, year] = datePart.split('.');
      // Объединяем дату и время в формат, который понимает JavaScript
      return new Date(`${year}-${month}-${day}T${timePart}`);
    }

    function updateTimer(endtime) {
      const timeInterval = setInterval(function() {
          const t = Date.parse(endtime) - Date.parse(new Date());
          if (t <= 0) {
              clearInterval(timeInterval);
              $('#days').text('0');
              $('#hours').text('0');
              $('#minutes').text('0');
              return;
          }
          const days = Math.floor(t / (1000 * 60 * 60 * 24));
          const hours = Math.floor((t / (1000 * 60 * 60)) % 24);
          const minutes = Math.floor((t / 1000 / 60) % 60);

          $('#days').text(days);
          $('#hours').text(hours);
          $('#minutes').text(minutes);
      }, 1000);
    }

    const endtimeStr = $('.promotion__timer').data('endtime');
    const endtime = parseDate(endtimeStr);
    updateTimer(endtime);
  }
}
timer();